import type { Category, CategorySlug } from '../types';
import { NewspaperEffect } from '@shared/components';
import './CategoryTabs.css';

interface CategoryTabsProps {
  categories: Category[];
  activeCategory: CategorySlug;
  onCategoryChange: (category: CategorySlug) => void;
}

export function CategoryTabs({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="category-tabs">
      <div className="container">
        <div className="category-tabs__nav" role="tablist">
          {categories.map((category) => {
            const isActive = activeCategory === category.slug;

            if (isActive) {
              return (
                <button
                  key={category.slug}
                  onClick={() => onCategoryChange(category.slug)}
                  className="category-tabs__newspaper-tab category-tabs__newspaper-tab--active"
                  role="tab"
                  aria-selected={isActive}
                  aria-controls={`category-panel-${category.slug}`}
                >
                  <NewspaperEffect className="category-tabs__newspaper-wrapper">
                    {category.displayName.toUpperCase()}
                  </NewspaperEffect>
                </button>
              );
            }

            return (
              <button
                key={category.slug}
                onClick={() => onCategoryChange(category.slug)}
                className="category-tabs__newspaper-tab"
                role="tab"
                aria-selected={isActive}
                aria-controls={`category-panel-${category.slug}`}
              >
                {category.displayName.toUpperCase()}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
